exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-body {\n\toverflow-x: unset;\n}\n.header-fixed .app-header {\n\tz-index: 1021;\n}\n.sidenav-sticky {\n\ttop: 68px;\n}\n.sidenav-sticky .card-footer {\n\tpadding: 2rem;\n\tbackground-color: #65a930;\n\tbackground: linear-gradient(90deg, #f4a261 0%, #e76f51 100%);\n\tcolor: white;\n}\n.sidenav-sticky .card-footer.success {\n\tbackground-color: #65a930;\n\tbackground: linear-gradient(90deg, #00af75 0%, #00a09c 100%);\n}\n.sidenav-sticky .card-footer .label {\n\tdisplay: block;\n\ttext-transform: uppercase;\n\tfont-size: 0.7rem;\n}\n.sidenav-sticky .card-footer .score {\n\tfont-size: 3rem;\n}\n", ""]);

// exports
